import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import styled from "styled-components";

const I18nStyled = styled(I18n)`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
`;

export const AddItemInputTitle = ({ itemsListType }) => {
    return (
        <p style={{ margin: 0, position: "absolute", top: 18, zIndex: 1 }}>
            {}
            <I18nStyled
                dangerouslySetInnerHTML
                dataObj={{ itemType: itemsListType }}
            >
                KeywordAnalysis.keywordgroup.wizard.list.input.placeholder
            </I18nStyled>
        </p>
    );
};
